

$(window).ready(function(){

        
    // Primary update cart function, handles adding/editing/deleting property
    function updateCart(monogramInput, monogramValue, linePosition, quantity, eventType, monogramHeader){
        // Set up the body of product data to update via AJAX
        // Based on event type (add/edit/delete)
        let dataBody = {}
        if(eventType == 'delete'){
            dataBody = {
                "line": linePosition,
                "quantity": quantity,
                "properties": { "Monogram": "" }
            }
        }else if(eventType == 'add' || eventType == 'edit'){
            dataBody = {
                "line": linePosition,
                "quantity": quantity,
                "properties": { "Monogram": `${monogramValue}` }
            }
        }

        
        // Send data to Shopify via AJAX to update cart
        fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(
                dataBody
            )
        })
        .then(response => {
            return response.json();
        })
        .then(function(data){
            if (data.status === 422) {
                this.error(data);
            } else {
                const product = data;
                document.dispatchEvent(new CustomEvent('cart:build'));
                if(monogramHeader){
                    const monogramWrapper = $(monogramInput).closest('.mg-mini-input-wrapper')
                    $(monogramWrapper).find('.mg-mini-edit').css('display', 'block')

                    $(monogramWrapper).find('.mg-mini-delete').css('display', 'block')
                 $(monogramHeader).text('Monogram:')
                    // $(monogramHeader).text('Want to add a free monogram?')
                }
                if($(monogramInput).find('.checkout-alert')){
                    $(monogramInput).find('.checkout-alert').remove()
                }
                if($('#error-msg-overlay')){
                    $('#error-msg-overlay').remove()
                }
                if(window.location.pathname.includes('cart')){
                    window.location.reload()
                }
                return product
            }
        })
        .catch((error) => {
            console.error('!!!Error:', error);
            return error
        })
    }


    function checkForIncompleteInputs() {
        $('.mg-mini-input').each(function(){
            $(this).on('focusout', function(){
                const checkoutButtonMiniCart =  $('.cart__checkout-wrapper')
                let existingError = $('#error-msg-overlay')
                if($(this).val() != ""){
                    // Overlay a transparent placeholder div over the mini cart checkout 
                    // when a monogram input value has been entered
                    // the placeholder is removed when the 'add' or 'edit' button has been clicked. 
                    if(!existingError || existingError.length == 0 ){
                        const checkoutTransparency = $('<div id="error-msg-overlay" class=" checkout-transparency"></div>')
                        $(checkoutButtonMiniCart).append($(checkoutTransparency))
                        setCheckoutErrorListener($(checkoutTransparency))
                    }
                    
                }
            })
        })
    }

    function setCheckoutErrorListener(checkoutTransparency) {
        $(checkoutTransparency).on('click', function(){
            // check if all inputs that have values entered have been actually 'added' 
            $('.mg-mini-input-wrapper').each(function(i, input){
                if($(input).hasClass('editing')){

                    // First clear existing errors
                    if($(input).siblings('.checkout-alert') && $(input).siblings('.checkout-alert').length > 0){
                        $(input).siblings('.checkout-alert').remove()
                    }
                    // First clear existing errors
                    if($(input).siblings('.monogram-error') && $(input).siblings('.monogram-error').length > 0){
                        $(input).siblings('.monogram-error').remove()
                    }
                    // Add new error
                    const error = $("<span class='checkout-alert'>Please press 'update' to continue</span>")
                    error.insertAfter($(input))
                }else if($(input).hasClass('adding')){
                    // First clear existing errors
                    if($(input).siblings('.checkout-alert') && $(input).siblings('.checkout-alert').length > 0){
                        $(input).siblings('.checkout-alert').remove()
                    }
                    // First clear existing errors
                    if($(input).siblings('.monogram-error') && $(input).siblings('.monogram-error').length > 0){
                        $(input).siblings('.monogram-error').remove()
                    }
                    // Add new error
                    const error = $("<span class='checkout-alert'>Please press 'add' to continue</span>")
                    error.insertAfter($(input))
                }
            })
            // if not, show error message

        })
    }
    function setMiniCartMonogramEvents(){
        // Check if input field has valid strings
        function isValid(str) {
            return /^[a-zA-Z0-9]+$/.test(str);
        }
  
        // Key up event for input fields in mini cart
        // Adds error if invalid text is entered. 
        $('.mg-mini-input').each(function(){
            $(this).on('keypress keyup', function(e){
                var key = e.key;
                if (!isValid(key)) {
                    e.target.value = e.target.value.replace(/[^a-z0-9\s]/gi, '');
                    e.preventDefault();
                    // return false;
                }else{
                    e.target.value = e.target.value.toUpperCase();
                    $(this).attr('value', e.target.value)
                    let wrapper = $(this).closest('.mg-mini-input-wrapper')
                    if($(wrapper).find('.mg-mini-add').css('display') == 'none'){
                        if(!$(wrapper).hasClass('editing')){
                            $(wrapper).addClass('editing')
                        }
                    }else{
                        if(!$(wrapper).hasClass('adding')){
                            $(wrapper).addClass('adding')
                        }
                    }
                }
            })
        });

        function handleClickEvent(element, eventType){
            const prodKey = $(element).closest('.cart__item').attr("data-key")
            const quantity = $(element).closest('.cart__item-details').find('.js-qty__num').val()
      
            let linePosition
            $(".cart__item").each(function(index, el){
                if($(el).attr('data-key') == prodKey){
                    linePosition = index + 1
                }
            })
            const monogramInput = $(element).closest('.mg-mini-input-wrapper').find(".mg-mini-input")
            const monogramHeader = $(element).closest('.mg-mini-container').find('.mg-mini-header')
            const monogramInputValue = $(monogramInput).val()
            const monogramValue =  monogramInputValue ? monogramInputValue : ""
            const monogramInputWrapper = $(element).closest('.mg-mini-input-wrapper')
            if(eventType == 'add'){
                $(monogramInput).removeAttr('disabled');
                if($(monogramInputWrapper).hasClass('editing')){
                    $(monogramInputWrapper).removeClass('editing');
                }else if($(monogramInputWrapper).hasClass('adding')){
                    $(monogramInputWrapper).removeClass('adding');
                }
                if(monogramValue == ""){
                    // Append error message
                    const existingError = $(element).closest('.mg-mini-container').find('.monogram-error');
    
                    if($(existingError).length == 0){
                        $('<span class="monogram-error">Please enter a value</span>').insertAfter(monogramInputWrapper);
                    }
                } else if (!isValid(monogramValue)) {
                    // Append error message for invalid input
                    const existingError = $(element).closest('.mg-mini-container').find('.monogram-error');
    
                    if($(existingError).length == 0){
                        $('<span class="monogram-error">Please enter only letters and numbers</span>').insertAfter(monogramInputWrapper);
                    }
                } else {
                    if($(this).closest('.mg-mini-container').find('.monogram-error') && $(this).closest('.mg-mini-container').find('.monogram-error').length > 0){
                        $('.monogram-error').remove();
                    }
                    updateCart(monogramInput, monogramValue, linePosition, quantity, eventType, monogramHeader);
                }
            }else if (eventType == 'edit'){
                $(monogramInput).removeAttr('disabled')
                $(monogramInputWrapper).addClass('editing')
            }else{
                updateCart(monogramInput, monogramValue, linePosition, quantity, eventType, monogramHeader)
                
            }
            
        }
        
        // Edit monogram click event
        $('.mg-mini-edit').each(function(){
            $(this).on('click', function(){
                handleClickEvent($(this), 'edit')
            })    
        })


        // Delete monogram click event
        $('.mg-mini-delete').each(function(){
            $(this).on('click', function(){
                handleClickEvent($(this), 'delete')
            })
        })

        // Add monogram click event
        $('.mg-mini-add').each(function(){
            $(this).on('click', function(){
                handleClickEvent($(this), 'add')
            })
        })


        // update monogram click event
        $('.mg-mini-update').each(function(){
            $(this).on('click', function(){
                handleClickEvent($(this), 'add')
            })
        })

    }

    setMiniCartMonogramEvents()
    $(".site-nav__link.js-drawer-open-cart").on('click touchstart', function(){
        setTimeout(function(){
            setMiniCartMonogramEvents()
            checkForIncompleteInputs()
        }, 500)
    })
    document.addEventListener("cart:updated", () => {
        // Once AJAX mini cart is updated, reset the click events on newly loaded elements
        setTimeout(function(){
            setMiniCartMonogramEvents()

        checkForIncompleteInputs()
        }, 500)
    });
    document.addEventListener('ajaxProduct:added', function(evt) {
        setTimeout(function(){
            setMiniCartMonogramEvents()
            checkForIncompleteInputs()
        }, 500)
      });
    document.addEventListener("cart:build", () => {
        // Once AJAX mini cart is updated, reset the click events on newly loaded elements
        setTimeout(function(){
            setMiniCartMonogramEvents()
            checkForIncompleteInputs()
        }, 500)
    });
})